var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      staticClass: "card-item pb-4 pt-5 px-5",
      on: { click: _vm.handleSelect }
    },
    [
      _c(
        "div",
        { staticClass: "pb-6 poistenie-card-img" },
        [
          _c(
            "v-row",
            { attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { staticClass: "pr-0px", attrs: { cols: "7" } },
                [
                  _c("v-img", {
                    attrs: {
                      src: _vm.getImage(_vm.value),
                      contain: "",
                      height: "48",
                      width: "100"
                    }
                  })
                ],
                1
              ),
              _c("v-col", { staticClass: "pl-0px", attrs: { cols: "5" } })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.value.displayMember,
              expression: "value.displayMember"
            }
          ],
          staticClass: "ponuka-info-1 pb-4 font-weight-bold"
        },
        [_c("p", [_vm._v(_vm._s(_vm.value.displayMember))])]
      ),
      _c(
        "div",
        { staticClass: "ponuka-info-2", staticStyle: { display: "flex" } },
        [
          _vm.value.spoluucast
            ? _c("v-col", { staticClass: "pa-0", attrs: { cols: "6" } }, [
                _c("div", { staticClass: "tr-label" }, [_vm._v("Spoluúčasť")]),
                _c("div", { staticClass: "tr-content" }, [
                  _vm._v(" " + _vm._s(_vm.value.spoluucast) + " ")
                ])
              ])
            : _vm._e(),
          !_vm.isOlfs
            ? _c(
                "v-col",
                {
                  staticClass: "pa-0",
                  style: _vm.value.spoluucast ? "text-align: right" : "",
                  attrs: { cols: "6" }
                },
                [
                  _c("div", { staticClass: "tr-label" }, [
                    _vm._v("Ročné poistné")
                  ]),
                  _c("div", { staticClass: "tr-content" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.value.poistne_rocne ? _vm.value.poistne_rocne : ""
                        ) +
                        " "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _c("v-spacer"),
      !_vm.isOlfs || _vm.addButton
        ? _c("v-divider", { staticClass: "my-2" })
        : _vm._e(),
      _c(
        "div",
        { staticClass: "poistenie-card-footer" },
        [
          !_vm.isOlfs
            ? _c(
                "v-icon",
                {
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.openDetailDialog(_vm.value)
                    }
                  }
                },
                [_vm._v(" $detail_zmluvy ")]
              )
            : _vm._e(),
          _c(
            "v-btn",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.addButton && _vm.isSelected,
                  expression: "addButton && isSelected"
                }
              ],
              staticClass: "pripoistenie-btn",
              attrs: { outlined: "" },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.addButtonClicked()
                }
              }
            },
            [_vm._v(" Pripoistenie "), _c("v-icon", [_vm._v(" mdi-plus ")])],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }